"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));
var _react = require("react");
var _cnbuilder = require("cnbuilder");
var _reactModal = _interopRequireDefault(require("react-modal"));
var _uuid = require("uuid");
var _reactI18next = require("react-i18next");
var _arrowLeftActive = _interopRequireDefault(require("@teladoc/pulse/icons/arrow-left-active.svg"));
var _Button = _interopRequireDefault(require("../Button"));
var _IconButton = _interopRequireDefault(require("../IconButton"));
var _Image = _interopRequireDefault(require("../Image"));
var _HeadingTitle = _interopRequireDefault(require("./HeadingTitle"));
var _ModalModule = _interopRequireDefault(require("./Modal.module.scss"));
var _jsxRuntime = require("react/jsx-runtime");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function checkAndSetAriaHiddenAttr() {
  const element = document.querySelectorAll('[data-react-modal-body-trap]')[1];
  if (element) {
    element.setAttribute('aria-hidden', 'true');
  } else {
    // Retry after a short delay
    setTimeout(checkAndSetAriaHiddenAttr, 100);
  }
}
const Modal = _ref => {
  let {
    classNameRoot,
    classNameShim,
    classNameContainer,
    classNameContent,
    testAttrPrevious,
    testAttrContainer,
    testAttrContent,
    title,
    titleLevel,
    subtitle,
    i18nPreviousLabel,
    children,
    isOpen,
    activeContentIndex,
    primaryAction,
    secondaryAction,
    tertiaryAction,
    disableCloseActions,
    onShown,
    onHidden,
    onContentIndexChange,
    onRequestClose,
    shouldCloseOnOverlayClick,
    scrollable,
    imageSrc,
    altText,
    testAttrImage
  } = _ref;
  const {
    t
  } = (0, _reactI18next.useTranslation)();
  const {
    current: uuid
  } = (0, _react.useRef)((0, _uuid.v4)());
  const titleId = "title-".concat(uuid);
  const contentId = "content-".concat(uuid);
  const withImage = imageSrc && altText;
  const threeActions = primaryAction && secondaryAction && tertiaryAction;
  const [isLargeScreen, setIsLargeScreen] = (0, _react.useState)(window.innerWidth >= 768);
  const onCloseRequested = () => {
    if (disableCloseActions) {
      return;
    }
    if (onRequestClose) {
      onRequestClose();
    }
  };
  (0, _react.useEffect)(() => {
    if (imageSrc && !altText) {
      throw new Error('The `altText` prop is required when the `imageSrc` prop is defined.');
    }
    if (!title) {
      // eslint-disable-next-line no-console
      console.warn('The `title` prop is required.');
    }

    // Initial call to start the checking process
    checkAndSetAriaHiddenAttr();
    const handleResize = () => {
      setIsLargeScreen(window.innerWidth >= 768);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const footerActions = {
    primary: primaryAction && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.default, _objectSpread(_objectSpread({}, primaryAction), {}, {
      className: (0, _cnbuilder.cnb)(_ModalModule.default.primary, primaryAction.className),
      variant: "primary"
    })),
    secondary: secondaryAction && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.default, _objectSpread(_objectSpread({}, secondaryAction), {}, {
      className: (0, _cnbuilder.cnb)(_ModalModule.default.secondary, secondaryAction.className),
      variant: "secondary"
    })),
    tertiary: tertiaryAction && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.default, _objectSpread(_objectSpread({}, tertiaryAction), {}, {
      className: (0, _cnbuilder.cnb)(_ModalModule.default.tertiary, {
        [_ModalModule.default['three-actions']]: threeActions
      }, tertiaryAction.className)
    }))
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactModal.default, {
    isOpen: isOpen,
    htmlOpenClassName: _ModalModule.default.open,
    portalClassName: (0, _cnbuilder.cnb)(_ModalModule.default.root, classNameRoot),
    overlayClassName: {
      base: (0, _cnbuilder.cnb)(_ModalModule.default.shim, classNameShim),
      afterOpen: _ModalModule.default.animateAfterOpen,
      beforeClose: _ModalModule.default.animateBeforeClose
    },
    className: {
      base: (0, _cnbuilder.cnb)(_ModalModule.default.container, classNameContainer, scrollable && _ModalModule.default['with-scroll']),
      afterOpen: _ModalModule.default.animateAfterOpen,
      beforeClose: _ModalModule.default.animateBeforeClose
    },
    closeTimeoutMS: 300,
    data: {
      testId: testAttrContainer
    },
    onAfterOpen: onShown,
    onAfterClose: onHidden,
    onRequestClose: onCloseRequested,
    shouldCloseOnOverlayClick: shouldCloseOnOverlayClick,
    children: [withImage && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Image.default, {
      classNameRoot: (0, _cnbuilder.cnb)(_ModalModule.default['image-container'], scrollable && _ModalModule.default['with-scroll']),
      className: _ModalModule.default.image,
      src: imageSrc,
      alt: altText,
      "data-testid": testAttrImage
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: (0, _cnbuilder.cnb)(_ModalModule.default.header, scrollable && _ModalModule.default['with-scroll']),
      children: [activeContentIndex > 0 && /*#__PURE__*/(0, _jsxRuntime.jsx)(_IconButton.default, {
        testAttr: testAttrPrevious,
        className: _ModalModule.default.previous,
        i18nLabel: i18nPreviousLabel || t('ui:modal.previous'),
        onClick: onContentIndexChange,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_arrowLeftActive.default, {})
      }), typeof title === 'string' ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_HeadingTitle.default, {
        className: (0, _cnbuilder.cnb)(_ModalModule.default.title, {
          [_ModalModule.default.titleIndented]: activeContentIndex > 0
        }),
        id: titleId,
        titleLevel: titleLevel,
        children: title
      }) : title]
    }), subtitle && /*#__PURE__*/(0, _jsxRuntime.jsx)("h2", {
      className: _ModalModule.default.subtitle,
      children: subtitle
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      id: contentId,
      className: (0, _cnbuilder.cnb)(classNameContent, withImage && _ModalModule.default['with-img'], scrollable && _ModalModule.default.scrollable),
      "data-testid": testAttrContent,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: _ModalModule.default['main-content'],
        "data-testid": "main-content",
        tabIndex: scrollable ? 0 : -1 // eslint-disable-line jsx-a11y/no-noninteractive-tabindex
        ,
        children: children
      })
    }), (primaryAction || secondaryAction || tertiaryAction) && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: (0, _cnbuilder.cnb)(_ModalModule.default.actions, scrollable && _ModalModule.default['with-scroll']),
      children: isLargeScreen ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
        children: [footerActions.tertiary, footerActions.secondary, footerActions.primary]
      }) : /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
        children: [footerActions.primary, footerActions.secondary, footerActions.tertiary]
      })
    })]
  });
};
Modal.defaultProps = {
  testAttrPrevious: 'modal-previous',
  testAttrContainer: 'modal-container',
  testAttrContent: 'content-container',
  testAttrPrimaryAction: 'modal-primary-action',
  testAttrSecondaryAction: 'modal-secondary-action',
  testAttrTertiaryAction: 'modal-tertiary-action',
  activeContentIndex: 0,
  shouldCloseOnOverlayClick: true,
  scrollable: false
};
var _default = exports.default = Modal;